import React, {useState} from "react";
import {TAB_GRADIENT} from "../constants/colors";
import {OMNISCAN_BLUE} from "../constants/colors";
import {TEXT_LIGHT} from "../constants/colors";

export default function MetricKpiBoxSmall({
    value,
    label,
    color = OMNISCAN_BLUE
})
{
    const [isHover, setIsHover] =
        useState(false);

    return (
        <div
            style={{
				overflow:"hidden",
                height: "55px",
                borderRadius: "4px",
                background: TAB_GRADIENT,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                transition: "all 0.2s ease",
                transform:
                    isHover
                        ? "translateY(-2px)"
                        : "translateY(0px)"
            }}
            onMouseEnter={() =>
            {
                setIsHover(true);
            }}
            onMouseLeave={() =>
            {
                setIsHover(false);
            }}
        >
            <div
                style={{
                    fontSize: "20px",
                    color: color,
                    lineHeight: "15px"
                }}
            >
                {value}
            </div>

            <div
                style={{
                    fontSize: "11px",
                    color: TEXT_LIGHT,
                    marginTop: "4px"
                }}
            >
                {label}
            </div>
        </div>
    );
}